// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"f7394bfa","513":"99119020","703":"65535e24"}[chunkId] + ".chunk.js";
};